import {
  ClientDetailsApiResponse,
  ClientFamilyApiResponse,
  PortfoliosApiResult,
  PortfolioApiResponse,
  StandardFeesApiResponse,
  ScenarioCoreDetailsResponse,
  Scenario,
} from './types';

export type State = {
  clientIsLoading: boolean;
  clientError: boolean;
  scenarioIsSaving: boolean;
  portfolios: Array<PortfoliosApiResult>;
  portfoliosIsLoading: boolean;
  clientDetails: ClientDetailsApiResponse;
  clientFamily: ClientFamilyApiResponse;
  portfolio: PortfolioApiResponse;
  portfolioIsLoading: boolean;
  standardFees: StandardFeesApiResponse;
  scenarios: Array<ScenarioCoreDetailsResponse>;
  scenario: Scenario;
  scenarioIsLoading: boolean;
};

export const state: State = {
  clientIsLoading: false,
  clientError: false,
  scenarioIsSaving: false,
  portfolios: [] as Array<PortfoliosApiResult>,
  portfoliosIsLoading: false,
  clientDetails: {} as ClientDetailsApiResponse,
  clientFamily: {} as ClientFamilyApiResponse,
  portfolio: {} as PortfolioApiResponse,
  portfolioIsLoading: false,
  standardFees: {} as StandardFeesApiResponse,
  scenarios: [] as Array<ScenarioCoreDetailsResponse>,
  scenario: {} as Scenario,
  scenarioIsLoading: false,
};
